const initialState = {
  showVideo: false,
  uploadPercentage:0,
  videoDetails:{},
};
const videoUploadedReducers = (state = initialState, action:any) => {
  switch (action.type) {
    case "showUploadedVideo":
      return {
        ...state,
        showVideo: action.showVideo
      };
      case "updatePercentage":
        return {
          ...state,
          uploadPercentage: action.uploadPercentage
        };
      case "updateVideoDetail":
        return {
          ...state,
          videoDetails: action.videoDetails
        };
    default:
      return state;
  }
  
};

export default videoUploadedReducers;